import { openMainFormSuccessPopup } from './mainForm.js';

const getFields = form => ( {
	name: form.querySelector( '[name="contacts_name"]' ),
	email: form.querySelector( '[name="contacts_email"]' ),
	message: form.querySelector( '[name="contacts_message"]' ),
} );

const clearValidation = form => {
	form.querySelectorAll( '.contacts__field' ).forEach( field => {
		field.classList.remove( '!border-[#E53935]' );
	} );
};

const validate = form => {
	const fields = getFields( form );
	const invalidFields = [];

	if ( !fields.name || fields.name.value.trim().length < 2 ) {
		invalidFields.push( 'contacts_name' );
	}

	if ( !fields.email || !fields.email.value.trim() || !fields.email.validity.valid ) {
		invalidFields.push( 'contacts_email' );
	}

	if ( !fields.message || !fields.message.value.trim() || fields.message.value.length > 5000 ) {
		invalidFields.push( 'contacts_message' );
	}

	clearValidation( form );

	invalidFields.forEach( fieldName => {
		const input = form.querySelector( `[name="${fieldName}"]` );
		const field = input ? input.closest( '.contacts__field' ) : null;

		field && field.classList.add( '!border-[#E53935]' );
	} );

	const firstInvalid = form.querySelector( `[name="${invalidFields[0]}"]` );

	if ( firstInvalid ) {
		firstInvalid.focus();
	}

	return invalidFields.length === 0;
};

const submit = async form => {
	if ( !validate( form ) ) {
		return;
	}

	const button = form.querySelector( '[type="submit"]' );

	button && ( button.disabled = true );

	try {
		const formData = new FormData( form );
		formData.append( 'action', 'submit_contacts_form' );
		formData.append( 'nonce', window.var_from_php?.contacts_form_nonce || '' );

		const response = await fetch( window.var_from_php.ajax_url, {
			method: 'POST',
			body: formData,
		} );
		const result = await response.json();

		if ( result.success ) {
			form.reset();
			clearValidation( form );
			openMainFormSuccessPopup();
			return;
		}

		if ( result.data && Array.isArray( result.data.fields ) ) {
			result.data.fields.forEach( fieldName => {
				const input = form.querySelector( `[name="${fieldName}"]` );
				const field = input ? input.closest( '.contacts__field' ) : null;

				field && field.classList.add( '!border-[#E53935]' );
			} );
		}
	} catch ( error ) {
		return;
	} finally {
		button && ( button.disabled = false );
	}
};

export function initContactsForms() {
	document.querySelectorAll( '[data-role="contacts-form"]' ).forEach( form => {
		form.addEventListener( 'submit', event => {
			event.preventDefault();
			submit( form );
		} );
	} );

	document.body.addEventListener( 'input', event => {
		const input = event.target.closest( '[data-role="contacts-form"] .contacts__input, [data-role="contacts-form"] .contacts__textarea' );

		if ( input && input.value.trim() ) {
			const field = input.closest( '.contacts__field' );
			field && field.classList.remove( '!border-[#E53935]' );
		}
	} );
}
